import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, IconButton, Typography } from "@mui/material";

type VideoPreviewDialogProps = {
  open: boolean;
  onClose: () => void;
  src: string;
  title?: string;
};

const VideoPreviewDialog = ({
  open,
  onClose,
  src,
  title,
}: VideoPreviewDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: { backgroundColor: "#000", borderRadius: "10px", overflow: "hidden" },
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        padding: "8px 8px 8px 16px",
      }}
    >
      <Typography
        title={title}
        sx={{
          color: "#fff",
          fontSize: "14px",
          fontWeight: 500,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>

      <IconButton onClick={onClose} size="small" aria-label="Close video">
        <CloseIcon sx={{ color: "#fff" }} />
      </IconButton>
    </Box>

    <Box
      component="video"
      src={src}
      controls
      autoPlay
      sx={{ width: "100%", maxHeight: "70vh", display: "block" }}
    />
  </Dialog>
);

export default VideoPreviewDialog;
